import Animal from "./Animal";
import Button from "./Button";
import Menu from "./Menu";
import crown from "../assets/crown.svg";
import { useEffect, useMemo, useState } from "react";
import SettingButton from "./SettingButton";

function Lobby({ players, startGame, winnerId, playerId, socket, gameActive, onLeave }) {
    const [leaderIndex, setLeaderIndex] = useState(0);

    const myIndex = useMemo(() => {
        return players.findIndex(p => p.id === playerId);
    }, [players, playerId]);

    const handleTransferLeader = (index) => {
        if (index >= 0 && index < players.length) {
            socket.emit('update_leader_index', index);
        }
    }

    useEffect(() => {
        const handleUpdateLeaderIndex = (index) => {
            setLeaderIndex(index);
        }

        socket.on('update_leader_index', handleUpdateLeaderIndex);

        socket.emit('update_leader_index', -69); // request the leader index using super secret number

        return () => {
            socket.off('update_leader_index', handleUpdateLeaderIndex);
        }
    }, [socket])

    return (
        <div className="flex flex-col gap-4 relative">
            <Menu>
                <Back onClick={onLeave} />
                { players && winnerId && players.filter(p => p.id === winnerId).map(player => {
                    return (
                        <p key={player.id} className="text-lg font-semibold mb-2 -translate-y-3">{player.name} won the game!</p>
                    )
                })}
                <p className="w-full text-left mb-3 font-semibold text-neutral-200">Players:</p>
                <ul className="w-full flex flex-col gap-2">
                    { players && players.map((p, index) => {
                        return (
                            <li key={p.id} className="flex justify-between items-center relative">
                                <div className="flex gap-2 items-center">
                                    <Animal onClick={myIndex === leaderIndex ? () => handleTransferLeader(index) : null} animal={p.animal} className={p.id === playerId ? 'bg-gradient-to-b from-neutral-200 via-neutral-100 to-teal-300 hover:cursor-default' : ''} />
                                    <p className="font-semibold text-neutral-100">{p.name}</p>
                                    {index === leaderIndex && (
                                        <img src={crown} alt="crown" className="w-[18px] z-[100] absolute -top-2 -left-2 -rotate-[35deg]" />
                                    )}
                                </div>
                                { p.winCount > 0 && <p className="mr-2 text-neutral-100">{p.winCount}</p>}
                            </li>
                        )
                    })}
                </ul>
                { !gameActive ? (
                    <>
                        { players && players.length > 1 && (
                            <Button onClick={startGame} text={'Start game'} className={'w-full mt-3'}/>
                        )}
                    </>
                ) : (
                    <p className='mt-3 font-semibold text-teal-400'>Game in progress</p>
                )}
            </Menu>
            <Settings socket={socket} active={players[leaderIndex]?.id === playerId}/>
        </div>
    )
}

function Settings({ socket, active }) {
    const [code, setCode] = useState('');
    const [isSevenZero, setIsSevenZero] = useState(false);
    const [isDrawToMatch, setIsDrawToMatch] = useState(false);
    const [isTwoStacking, setIsTwoStacking] = useState(false);
    const [isFourStacking, setisFourStacking] = useState(false);
    const [isRainbow, setIsRainbow] = useState(false);
    const [isFlashbang, setIsFlashbang] = useState(false);

    const toggleSevenZero = () => {
        // emit to server to update seven zero
        socket.emit('update_setting', 'isSevenZero', !isSevenZero);
    }

    const toggleDrawToMatch = () => {
        socket.emit('update_setting', 'isDrawToMatch', !isDrawToMatch);
    }

    const toggleTwoStacking = () => {
        socket.emit('update_setting', 'isTwoStacking', !isTwoStacking)
    }

    const toggleFourStacking = () => {
        socket.emit('update_setting', 'isFourStacking', !isFourStacking);
    }

    const toggleRainbow = () => {
        socket.emit('update_setting', 'isRainbow', !isRainbow)
    }

    const toggleFlashbang = () => {
        socket.emit('update_setting', 'isFlashbang', !isFlashbang);
    }

    useEffect(() => {
        const handleKeyPress = (e) => {
            setCode((prev) => (prev + e.key));
        };

        window.addEventListener('keydown', handleKeyPress);

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    const showFlash = useMemo(() => {
        return code.includes('flash')
    }, [code]);

    useEffect(() => {
        const handleUpdateSetting = (setting, value) => {
            switch (setting) {
                case 'isSevenZero':
                    setIsSevenZero(value);
                    break;
                case 'isDrawToMatch':
                    setIsDrawToMatch(value);
                    break;
                case 'isTwoStacking':
                    setIsTwoStacking(value);
                    break;
                case 'isFourStacking':
                    setisFourStacking(value);
                    break;
                case 'isRainbow':
                    setIsRainbow(value);
                    break;
                case 'isFlashbang':
                    setIsFlashbang(value);
                    break;
                default:
                    break;
            }
        }

        socket.on('update_setting', handleUpdateSetting);

        // get all previous settings
        socket.emit('get_settings');
    
        return () => {
          socket.off('update_setting', handleUpdateSetting);
        }
    }, [socket]);

    return (
        <div className='lg:absolute bottom-0 left-[282px] bg-black/35 border border-gray-400 rounded-md p-5 pb-[22px] flex justify-center items-center flex-col w-[250px]'>
            <p className="w-full text-left font-semibold text-neutral-200">Settings:</p>
            <Setting>
                <p className="font-semibold">7-0</p>
                <SettingButton onClick={toggleSevenZero} active={active} text={isSevenZero ? 'On' : 'Off'} style={isSevenZero ? 'yay' : 'nay'}></SettingButton>
            </Setting>
            <Setting>
                <p className="font-semibold">Stack +2</p>
                <SettingButton onClick={toggleTwoStacking} active={active} text={isTwoStacking ? 'On' : 'Off'} style={isTwoStacking ? 'yay' : 'nay'}></SettingButton>
            </Setting>
            <Setting>
                <p className="font-semibold">Stack +4</p>
                <SettingButton onClick={toggleFourStacking} active={active} text={isFourStacking ? 'On' : 'Off'} style={isFourStacking ? 'yay' : 'nay'}></SettingButton>
            </Setting>
            <Setting>
                <p className="font-semibold">Rainbow</p>
                <SettingButton onClick={toggleRainbow} active={active} text={isRainbow ? 'On' : 'Off'} style={isRainbow ? 'slay' : 'nay'}></SettingButton>
            </Setting>
            <Setting>
                <p className="font-semibold">Draw to match</p>
                <SettingButton onClick={toggleDrawToMatch} active={active} text={isDrawToMatch ? 'On' : 'Off'} style={isDrawToMatch ? 'yay' : 'nay'}></SettingButton>
            </Setting>
            { showFlash && (
                <Setting>
                    <p className="font-semibold">Flashbang</p>
                    <SettingButton onClick={toggleFlashbang} active={active} text={isFlashbang ? 'On' : 'Off'} style={isFlashbang ? 'flash' : 'nay'}></SettingButton>
                </Setting>
            )}
        </div>
    )
}

function Setting({ children }) {
    return (
        <div className="w-full flex justify-between items-center mt-3 pb-0.5 px-1">
            { children }
        </div>
    )
}

function Back({ onClick }) {
    return (
        <button
            onClick={onClick}
            className="absolute top-0 left-0 px-1 py-2 w-7"
        >
            <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="fill-current text-neutral-400 hover:text-neutral-300 transition"
            >
                <g id="SVGRepo_iconCarrier">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M19 23H11C10.4477 23 10 22.5523 10 22C10 21.4477 10.4477 21 11 21H19C19.5523 21 20 20.5523 20 20V4C20 3.44772 19.5523 3 19 3L11 3C10.4477 3 10 2.55229 10 2C10 1.44772 10.4477 1 11 1L19 1C20.6569 1 22 2.34315 22 4V20C22 21.6569 20.6569 23 19 23Z"/> 
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.48861 13.3099C1.83712 12.5581 1.83712 11.4419 2.48862 10.6902L6.66532 5.87088C7.87786 4.47179 10.1767 5.32933 10.1767 7.18074L10.1767 9.00001H16.1767C17.2813 9.00001 18.1767 9.89544 18.1767 11V13C18.1767 14.1046 17.2813 15 16.1767 15L10.1767 15V16.8193C10.1767 18.6707 7.87786 19.5282 6.66532 18.1291L2.48861 13.3099ZM4.5676 11.3451C4.24185 11.7209 4.24185 12.2791 4.5676 12.6549L8.1767 16.8193V14.5C8.1767 13.6716 8.84827 13 9.6767 13L16.1767 13V11L9.6767 11C8.84827 11 8.1767 10.3284 8.1767 9.50001L8.1767 7.18074L4.5676 11.3451Z"/>
                </g>
            </svg>
        </button>
    );
}

export default Lobby;